<template>
  <v-dialog
    v-model="core.aboutDialog"
    scrollable
    max-width="600"
    max-height="400"
    :style="`z-index: ${core.app.confirmationIndex};position: fixed;`"
  >
    <!-- <template v-slot:activator="{ on, attrs }"> -->
    <!-- <v-btn
        text
        v-bind="attrs"
        v-on="on"
        @click.stop="
          app.menuSettings = false;
          app.aboutDialog = true;
        "
        class="appbar_menu_about"
      >
        {{ $t("common.aboutDialog.title") }}
      </v-btn> -->
    <!-- hide title <v-btn
                    text
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="appbar_menu_about"
                    :title="$t('common.leftBarUpdateSelectMarker(')"
                  >
                    {{ $t("common.leftBarUpdateSelectMarker(") }}
                  </v-btn> -->
    <!-- </template> -->
    <v-card>
      <v-toolbar class="dialog_toolbar" dark color="primary">
        <v-toolbar-title v-if="isAbout" class="about-dialog">{{
          $t("common.aboutDialog.title")
        }}</v-toolbar-title>
        <v-toolbar-title v-if="!isAbout" class="FAQ-dialog">{{
          $t("common.aboutDialog.title_tab_FAQ")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="core.aboutDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title></v-card-title>
      <template v-if="isAbout">
        <v-card-text>
          {{ $t("common.aboutDialog.subtitle") }} <br /><br />
          {{ $t("common.aboutDialog.content") }} <br /><br />
          {{ $t("common.aboutDialog.content_pointOne") }}<br /><br />
          {{ $t("common.aboutDialog.content_pointTwo") }}<br /><br />
          {{ $t("common.aboutDialog.content_pointThree") }}
        </v-card-text>
        <v-card-text v-html="$t('common.aboutDialog.content_pointFour')"></v-card-text>
      </template>
      <template v-else>
        <!-- <v-card-text style="height: 325px" class="FAQ-box"> -->
        <v-card-text>
          <template v-for="(faq_item, i) in FAQ_items">
            <v-expansion-panels :key="i" style="padding-bottom: 15px" popout>
              <h6 class="primary--text" v-html="$t(faq_item.name)"></h6>
              <v-expansion-panel v-for="(item, j) in faq_item.children" :key="j">
                <v-expansion-panel-header>{{ $t(item.name) }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="primary--text" v-html="$t(item.children[0].name)"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <!-- <v-treeview
            v-if="!isAbout"
            :items="FAQ_items"
            :open="FAQ_items_initiallyOpen"
          >
            <template v-slot:label="{ item }">
              <div
                v-if="item.children != undefined && item.children.length > 1"
                class="v-treeview-node__header"
              >
                <p v-html="$t(item.name)"></p>
              </div>
              <div
                v-if="item.children != undefined && item.children.length == 1"
                class="v-treeview-node__question"
              >
                <p v-html="$t(item.name)"></p>
              </div>
              <div
                v-if="item.children == undefined"
                class="v-treeview-node__answer"
              >
                <p class="FAQ_answer" v-html="$t(item.name)"></p>
              </div>
            </template>
          </v-treeview> -->
        </v-card-text>
      </template>
      <hr />

      <v-container>
        <v-row>
          <v-col xs="12" sm="12" md="2" cols="12" align="center" justify="center"
            ><v-btn text small color="primary" @click="isAbout = true"
              >{{ $t("common.aboutDialog.title") }}
            </v-btn></v-col
          >
          <v-col xs="12" sm="12" md="8" cols="12" align="center" justify="center">
            <v-btn
              text
              small
              color="primary"
              @click="openTermsAndConditionLink($i18n.locale)"
              >{{ $t("common.aboutDialog.title_termsAndConditions") }}
            </v-btn>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" cols="12" align="center" justify="center">
            <v-btn
              text
              small
              color="primary"
              @click="openPrivacyPolicyLink($i18n.locale)"
              >{{ $t("common.aboutDialog.title_privacyPolicy") }}
            </v-btn>
          </v-col> -->
          <v-col xs="12" sm="12" md="2" cols="12" align="center" justify="center">
            <v-btn text small color="primary" @click="isAbout = false"
              >{{ $t("common.aboutDialog.tab_FAQ") }}
            </v-btn>
          </v-col>
          <v-col xs="12" sm="12" md="12" cols="12" align="center" justify="center">
            <v-btn text small color="primary" @click="core.introVideo.visible = true"
              >{{ $t("common.aboutDialog.tab_intro_video") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <!-- About - Terms And Condition -->
      <!-- hide title <div class="TermsAndCondition">
                      <span
                        style="display: inline"
                        @click="openTermsAndConditionLink($i18n.locale)"
                        :title="$t('common.leftBarUpdateSelectMarker(')"
                      >
                        <v-btn icon small color="primary"
                          >{{ $t("common.leftBarUpdateSelectMarker(") }}
                        </v-btn></span
                      >
                    </div> -->
      <!-- About - Privacy Policy -->
      <!-- hide title <div class="PrivacyPolicy">
                      <span
                        style="display: inline"
                        @click="openPrivacyPolicyLink($i18n.locale)"
                        :title="$t('common.leftBarUpdateSelectMarker(')"
                      >
                        <v-btn icon small color="primary"
                          >{{ $t("common.leftBarUpdateSelectMarker(") }}
                        </v-btn></span
                      >
                    </div> -->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      isAbout: true,
      FAQ_items_initiallyOpen: [1, 8],
      FAQ_items: [
        {
          id: 1,
          name: "common.aboutDialog.title_FAQ1",
          children: [
            {
              id: 2,
              name: "common.aboutDialog.title_FAQ1A",
              children: [{ id: 3, name: "common.aboutDialog.content_FAQ1A" }],
            },
            {
              id: 4,
              name: "common.aboutDialog.title_FAQ1B",
              children: [{ id: 5, name: "common.aboutDialog.content_FAQ1B" }],
            },
            {
              id: 6,
              name: "common.aboutDialog.title_FAQ1C",
              children: [{ id: 7, name: "common.aboutDialog.content_FAQ1C" }],
            },
          ],
        },
        {
          id: 8,
          name: "common.aboutDialog.title_FAQ2",
          children: [
            {
              id: 9,
              name: "common.aboutDialog.title_FAQ2A",
              children: [{ id: 10, name: "common.aboutDialog.content_FAQ2A" }],
            },
            {
              id: 11,
              name: "common.aboutDialog.title_FAQ2B",
              children: [{ id: 12, name: "common.aboutDialog.content_FAQ2B" }],
            },
            {
              id: 13,
              name: "common.aboutDialog.title_FAQ2C",
              children: [{ id: 14, name: "common.aboutDialog.content_FAQ2C" }],
            },
            {
              id: 15,
              name: "common.aboutDialog.title_FAQ2D",
              children: [{ id: 16, name: "common.aboutDialog.content_FAQ2D" }],
            },
            {
              id: 17,
              name: "common.aboutDialog.title_FAQ2E",
              children: [{ id: 18, name: "common.aboutDialog.content_FAQ2E" }],
            },
            {
              id: 19,
              name: "common.aboutDialog.title_FAQ2F",
              children: [{ id: 20, name: "common.aboutDialog.content_FAQ2F" }],
            },
            {
              id: 21,
              name: "common.aboutDialog.title_FAQ2G",
              children: [{ id: 22, name: "common.aboutDialog.content_FAQ2G" }],
            },
            {
              id: 23,
              name: "common.aboutDialog.title_FAQ2H",
              children: [{ id: 24, name: "common.aboutDialog.content_FAQ2H" }],
            },
            {
              id: 25,
              name: "common.aboutDialog.title_FAQ2I",
              children: [{ id: 26, name: "common.aboutDialog.content_FAQ2I" }],
            },
          ],
        },
      ],
    };
  },
  props: ["core"],
  methods: {
    openTermsAndConditionLink: function (locale) {


      let url = "https://portal.csdi.gov.hk/csdi-webpage/doc/TNC"
      url += (locale === this.core.GLOBAL.LANG.EN) ? "?lang=en" : (locale === this.core.GLOBAL.LANG.ZH) ? "?lang=zh-hk" : ""
      window.open(url, "_blank")

      // if (locale === this.core.GLOBAL.LANG.EN) {
      //   window.open("https://geodata.gov.hk/gs/?p=terms_and_conditions", "_blank");
      // } else if (locale === this.core.GLOBAL.LANG.ZH) {
      //   window.open(
      //     "https://geodata.gov.hk/gs/?p=terms_and_conditions&l=zh-Hant-HK",
      //     "_blank"
      //   );
      // }
    },
    openPrivacyPolicyLink: function (locale) {

      let url = "https://portal.csdi.gov.hk/csdi-webpage/doc/TNC"
      url += (locale === this.core.GLOBAL.LANG.EN) ? "?lang=en" : (locale === this.core.GLOBAL.LANG.ZH) ? "?lang=zh-hk" : ""
      window.open(url, "_blank")
      
      // if (locale === this.core.GLOBAL.LANG.EN) {
      //   window.open(
      //     "https://geodata.gov.hk/gs/?p=terms_and_conditions#h2-privacy-policy",
      //     "_blank"
      //   );
      // } else if (locale === this.core.GLOBAL.LANG.ZH) {
      //   window.open(
      //     "https://geodata.gov.hk/gs/?p=terms_and_conditions&l=zh-Hant-HK#h2-privacy-policy",
      //     "_blank"
      //   );
      // }
    },
  },
};
</script>
